<script lang="ts" setup>
import { Mask, MaskUtils } from '~/enums/mask'

const model = defineModel<number>()

const props = withDefaults(
  defineProps<{
    isSmall?: boolean
    isWide?: boolean
    isWideOnMobile?: boolean
    max?: number
    min?: number
    multiplicity?: number
  }>(),
  { isSmall: false, isWide: false, isWideOnMobile: false, max: 1000, min: 1, multiplicity: 1 }
)

const maskaOptions = { number: MaskUtils.getMaskaOptions(Mask.Number) }

const fakeInput = ref<HTMLElement | null>(null)

const remainder = computed(() => model.value! % props.multiplicity)

watch(model, updateWidthFakeInput)

onMounted(updateWidthFakeInput)

function decreaseQuantity (): void {
  const deltaQuantity = remainder.value === 0 ? props.multiplicity : remainder.value

  updateValue(model.value! - deltaQuantity)
}

function increaseQuantity (): void {
  const deltaQuantity = remainder.value === 0 ? props.multiplicity : props.multiplicity - remainder.value

  updateValue(model.value! + deltaQuantity)
}

function handleBlur (): void {
  const valueAsNumber = Number(model.value)
  const { min, max } = props

  if (isNaN(valueAsNumber) || valueAsNumber < min) {
    model.value = min
  } else if (valueAsNumber > max) {
    model.value = max
  }
}

function updateValue (x: number): void {
  if (x >= props.min && x <= props.max) {
    model.value = x
  }
}

function updateWidthFakeInput (): void {
  if (fakeInput.value) {
    fakeInput.value.innerHTML = String(model.value)
  }
}
</script>

<template>
  <div
    class="box-border flex h-[30px] w-[90px] items-center justify-between rounded-lg bg-main-gray-low px-3 py-[10px]"
    :class="{ small: isSmall, wide: isWide, 'wide-on-mobile': isWideOnMobile }"
  >
    <SvgIcon
      class="cursor-pointer !text-lg font-medium text-main-green"
      :class="{ disabled: model === min }"
      name="outlined/remove"
      @click="decreaseQuantity"
    />

    <span ref="fakeInput" aria-hidden="true" class="text-xs font-medium" />

    <SvgIcon
      class="cursor-pointer !text-lg font-medium text-main-green"
      :class="{ disabled: model === max }"
      name="outlined/add"
      @click="increaseQuantity"
    />
  </div>
</template>
